import React from "react";
import { dispatch } from "@rematch/core";
import { debounce } from "lodash";
import {
  app,
  accountService,
  accountUserWorkspacesService,
  setDefaultAccountService,
  categoriesService,
  invitesService,
  declinedInvitesService,
  checkCategoryService,
  accountUpgradeService,
  tagsService,
  tagsTreeService,
  deactivateAccountService,
  activateAccountService,
  tagUsageService,
  organizationService,
  publicAccessService,
  topUpFreeCreditsService,
  categoriesExportService,
  categoriesImportService,
  categoriesWorkspaceImportService,
  organizationAPIKeyService,
  userAccountCacheService,
  createSubscriptionService,
  upgradeService,
  accountUserMetadataService,
  checkoutSessionService,
  customerSessionService,
  apiKeyService,
  usersWhichPublishedContentService,
  usersWhichPublishedPlaybookService,
  usersWhichPublishedInitiativesService,
  GetConsumptionDetailsService,
  ExportConsumptionDetailsExcelService,
  ConsumptionBillingService,
} from "../../services/feathers.service";
import { toastr } from "react-redux-toastr";
import { push } from "react-router-redux";

import UserCache from "../../helpers/cache/userCache";

const initialState = {
  organizationList: {
    data: null,
    total: 0,
  },
  allAccounts: [],
  isCategoryChange: false,
  isAddCategoryModalOpen: false,
  isDeleteCategoryModalOpen: false,
  accountInvitedUser: null,
  selectedCategory: null,
  categoryTreeId: {},
  tagsTree: [],
  tags: [],
  selectedTag: {},
  tagMap: null,
  deActivateAccountModal: false,
  userWorkspacesTotal: 0,
  openViewAccountFlag: false,
  categoriesToExport: null,
  orgsWithAPIKeys: [],
  consumptionDetails: [],
  activitiesGenerated: 0,
  playbooksCreated: 0,
  linksGenerated: 0,
  billingDefaults: {},
  accountSelectorLoader:false,
};

export default {
  state: initialState,
  reducers: {
    setOrganizationList(state, payload) {
      return {
        ...state,
        organizationList: payload,
      };
    },
    setBillingDefaults(state, payload) {
      return {
        ...state,
        billingDefaults: payload,
      };
    },
    setWorkspacesTotalCount(state, payload) {
      return {
        ...state,
        userWorkspacesTotal: payload,
      };
    },

    setAllAccounts(state, payload) {
      return {
        ...state,
        allAccounts: payload,
      };
    },

    setIsCategoryChangeFlag(state, payload) {
      return {
        ...state,
        isCategoryChange: payload,
      };
    },

    setAddCategoryModalFlag(state, payload) {
      return {
        ...state,
        isAddCategoryModalOpen: payload,
      };
    },
    setDeleteCategoryModalFlag(state, payload) {
      return {
        ...state,
        isDeleteCategoryModalOpen: payload,
      };
    },

    setAccountInvitedUserData(state, payload) {
      return {
        ...state,
        accountInvitedUser: payload,
      };
    },
    setSelectedCategory(state, payload) {
      return {
        ...state,
        selectedCategory: payload,
      };
    },
    setAccountSelectorLoader(state, payload){
      return {
        ...state,
        accountSelectorLoader: payload
      }
    },
    
    paramsTreeId(state, payload) {
      return {
        ...state,
        categoryTreeId: payload,
      };
    },
    setTagsTree(state, payload) {
      let tagMap = new Map();
      for (let baseTag of payload) {
        tagMap.set(baseTag._id.toString(), baseTag);
        if (baseTag.nodes) {
          for (let tag of baseTag.nodes) {
            tagMap.set(tag._id.toString(), tag);
            if (tag.nodes) {
              for (let subTag of tag.nodes) {
                tagMap.set(subTag._id.toString(), subTag);
              }
            }
          }
        }
      }
      return {
        ...state,
        tagsTree: payload,
        tagMap: tagMap,
      };
    },
    setTags(state, payload) {
      return {
        ...state,
        tags: payload,
      };
    },
    setSelectedTag(state, payload) {
      return {
        ...state,
        selectedTag: payload,
      };
    },
    setDeActivateAccountModal(state, payload) {
      return {
        ...state,
        deActivateAccountModal: payload,
      };
    },
    setViewAccountFlag(state, payload) {
      return {
        ...state,
        openViewAccountFlag: payload,
      };
    },
    setCategoriesToExport(state, payload) {
      return {
        ...state,
        categoriesToExport: payload,
      };
    },
    setOrgsWithAPIKeys(state, payload) {
      return {
        ...state,
        orgsWithAPIKeys: payload,
      };
    },
    setConsumptionDetails(state, payload) {
      return {
        ...state,
        consumptionDetails: payload,
      };
    },
    setActivitiesGenerated(state, payload) {
      return {
        ...state,
        activitiesGenerated: payload,
      };
    },
    setPlaybooksCreated(state, payload) {
      return {
        ...state,
        playbooksCreated: payload,
      };
    },
    setLinksGenerated(state, payload) {
      return {
        ...state,
        linksGenerated: payload,
      };
    },
    clear(state) {
      return { ...initialState };
    },
  },
  effects: {
    getAcountUserWorkspaces: debounce(async function (payload, state) {
      try {
        // payload.accountId = state.app.selectedAccount._id;
        // payload.users = {
        //     $elemMatch: {
        //         accountUserId: state.app.user._id
        //     }
        // }
        let query = {
          accountId: state.app.selectedAccount._id,
          users: {
            $elemMatch: {
              accountUserId: state.app.user._id,
            },
          },
          $populate: [
            {
              path: "users.accountUserId",
              select: "_id firstName lastName profilePic email",
            },
          ],
          $limit: payload.$limit,
          $skip: payload.$skip,
          $sort: payload.$sort,
          $or: payload.$or,
          $and: payload.$and,
        };

        const accountUserWorkspaces = await organizationService.find({
          query: query,
        });

        if (accountUserWorkspaces.total === 0) {
          dispatch.account.setWorkspacesTotalCount(0);
          dispatch.account.setOrganizationList({
            data: [],
            total: 0,
          });
        } else {
          const AUW = await accountUserWorkspacesService.find({
            query: {
              accountId: state.app.selectedAccount._id,
              accountUserId: state.app.user._id,
            },
          });
          dispatch.account.setWorkspacesTotalCount(
            AUW.data[0].organizations.length
          );
          let userCacheData = await userAccountCacheService.get(
            state.app.selectedAccount._id
          );

          const userCacheObject = new UserCache(userCacheData.obj);
          const orgDataMap = userCacheObject.getAccountWorkspaceDataStats();

          for (
            let index = 0;
            index < accountUserWorkspaces.data.length;
            index++
          ) {
            let element = accountUserWorkspaces.data[index];

            accountUserWorkspaces.data[index].default =
              AUW.data[0].organizations.filter((org) => {
                return org.id.toString() === element._id.toString();
              })[0].default;

            accountUserWorkspaces.data[index].active =
              AUW.data[0].organizations.filter((org) => {
                return org.id.toString() === element._id.toString();
              })[0].active;

            accountUserWorkspaces.data[index].id = element._id;
            accountUserWorkspaces.data[index].Communities = orgDataMap.get(
              element._id
            )
              ? orgDataMap.get(element._id).totalTeams
              : 0;
            accountUserWorkspaces.data[index].Initiatives = orgDataMap.get(
              element._id
            )
              ? orgDataMap.get(element._id).totalInitiatives
              : 0;
            accountUserWorkspaces.data[index].Playbooks = orgDataMap.get(
              element._id
            )
              ? orgDataMap.get(element._id).totalPlayBooks
              : 0;
            accountUserWorkspaces.data[index].Content = orgDataMap.get(
              element._id
            )
              ? orgDataMap.get(element._id).totalContents
              : 0;
            accountUserWorkspaces.data[index].role = accountUserWorkspaces.data[
              index
            ].users.filter((user) => {
              return user.accountUserId._id === state.app.user._id.toString();
            })[0].role;
          }
          dispatch.account.setOrganizationList(accountUserWorkspaces);
        }
        if(payload && payload.isLoaderEnabled) dispatch.account.setAccountSelectorLoader(false);
      } catch (e) {
        console.error("Error while fetching Workspace list - ", e);
        if(payload && payload.isLoaderEnabled) dispatch.account.setAccountSelectorLoader(false);
      }
    }, 700),

    async setDefaultAccount(payload) {
      try {
        await setDefaultAccountService.patch(payload.accountId, payload);
        dispatch.account.getAllAccounts();
      } catch (error) {
        throw error;
      }
    },

    async selectAccount(payload, state) {
      try {
        const accountDetails = await accountService.get(payload.accountId, {
          query: {
            $select: [
              "_id",
              "workspaceCount",
              "accountSetupStateNumber",
              "isActive",
              "isPlatformAccount",
              "publicAccess",
              "name",
              "timeZone",
              "ownerId",
              "subscriptionId",
              "customerId",
              "subscriptionType",
              "planId",
              "planDisplayName",
              "email",
              "currencyCode",
              "actionDate",
              "actionLogs",
              "createdAt",
              "updatedAt",
              "approvedAt",
              "lastUpdatedBy",
              "integrations",
              "logo",
              "users",
              "freeCreditsRemaining",
            ],
            $populate: [
              { path: 'users.id', select: '_id firstName lastName profilePic email isPlatformUser' },
              {
                path: "integrations.id",
                select:
                  "_id id label image version description createdAt formBuilder",
              },
            ],
          },
        });
        await dispatch.app.setSelectedAccountData(accountDetails);
        await dispatch.app.setAccountSubscriptionDetails(payload.accountId);
        // dispatch.app.setCurrentContext("designer");
      } catch (error) {
        throw error;
      }
    },

    async setSelectedAccountDataForContentManagement(payload, state) {
      try {
        const accounts = await usersWhichPublishedContentService.find(payload);
        await dispatch.app.setSelectedAccountDataUserList(accounts);
      } catch (error) {
        throw error;
      }
    },

    async setSelectedAccountDataForPlaybookManagement(payload, state) {
      try {
        const accounts = await usersWhichPublishedPlaybookService.find(payload);
        await dispatch.app.setSelectedAccountDataUserList(accounts);
      } catch (error) {
        throw error;
      }
    },
    async createCheckoutSession(payload, state) {
      try {
        const checkoutSession = await checkoutSessionService.create(payload);
        window.location.href = checkoutSession.url;
      } catch (error) {
        throw error;
      }
    },
    async createCustomerSession(payload, state) {
      try {
        const customerSession = await customerSessionService.create(payload);
        window.location.href = customerSession.url;
      } catch (error) {
        throw error;
      }
    },

    async subscriptionUpgradeService(payload, state){
      try {
        const subscriptionIntent = await upgradeService.create(payload);
        window.location.href = subscriptionIntent.invoiceUrl
      } catch (error) {
        throw error;
      }
    },
    async setSelectedAccountDataForInitiativeManagement(payload, state) {
      try {
        const accounts = await usersWhichPublishedInitiativesService.find(payload);
        await dispatch.app.setSelectedAccountDataUserList(accounts);
      } catch (error) {
        throw error;
      }
    },
    async getAllAccounts(accountUserId, state) {
      try {
        let accounts = await accountService.find({
          query: {
            $select: ["name", "logo", "isActive"],
          },
        });

        let AUWsData = await accountUserWorkspacesService.find({
          query: {
            accountUserId: state.app.user._id,
            accountCheckNotRequired: true,
          },
        });
        if (accounts.data.length > 0) {
          accounts.data.forEach((account) => {
            let selectedAcc = AUWsData.data.filter((auws) => {
              return account._id.toString() === auws.accountId.toString();
            })[0];
            if (selectedAcc) {
              account.workspaceCount = selectedAcc.organizations.length;
            } else {
              account.workspaceCount = 0;
            }
          });
          dispatch.account.setAllAccounts(accounts.data);
        } else {
          dispatch.account.setAllAccounts([]);
        }
      } catch (error) {
        throw error;
      }
    },

    setIsCategoryChange(payload) {
      dispatch.account.setIsCategoryChangeFlag(payload);
    },

    setAddCategoryModal(payload) {
      dispatch.account.setAddCategoryModalFlag(payload);
    },

    // Moved in to categories model
    async deleteCategoryAsync(payload) {
      // try {
      //     await categoriesService.remove(payload.categoryId);
      //     await dispatch.account.setSelectedCategoryAsync({})
      //     await dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": payload.accountId });
      //     if (payload.categoryType === 'baseCategory') {
      //         await dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": payload.accountId });
      //         toastr.success('Message', 'Knowledge Bank Deleted successfully')
      //         // if (payload.isPlatform) {
      //         //     return dispatch(push(`/app/platform/settings/public`));
      //         // }
      //         // else {
      //         //     return dispatch(push(`/app/${payload.accountId}/settings/knowledgeBank`));
      //         // }
      //     }
      //     else if (payload.categoryType === 'category') {
      //         await dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": payload.accountId });
      //         await dispatch.account.setIsCategoryChange(true);
      //         toastr.success('Message', 'Category Deleted successfully')
      //         // if (payload.isPlatform) {
      //         //     return dispatch(push(`/app/platform/settings/public/${payload.categoryTreeId.baseCategoryId}`));
      //         // }
      //         // else {
      //         //     return dispatch(push(`/app/${payload.accountId}/settings/knowledgeBank/${payload.categoryTreeId.baseCategoryId}`));
      //         // }
      //     }
      //     else if (payload.categoryType === 'subCategory') {
      //         await dispatch.account.setIsCategoryChange(true);
      //         toastr.success('Message', 'Sub Category Deleted successfully')
      //         // if (payload.isPlatform) {
      //         //     return dispatch(push(`/app/platform/settings/public/${payload.categoryTreeId.baseCategoryId}/${payload.categoryTreeId.categoryId}`));
      //         // }
      //         // else {
      //         //     return dispatch(push(`/app/${payload.accountId}/settings/knowledgeBank/${payload.categoryTreeId.baseCategoryId}/${payload.categoryTreeId.categoryId}`));
      //         // }
      //     }
      // }
      // catch (error) {
      //     throw error;
      // }
    },
    // Moved in to categories model
    async updateCategory(payload) {
      try {
        // // if (payload.categoryType === 'baseCategory') {
        // let updateValue;
        // if (payload.updatedName) {
        //     updateValue = { 'name': payload.updatedName }
        // }
        // if (payload.image) {
        //     updateValue = { 'image': payload.image }
        // }
        // if (payload.showWorkspace) {
        //     updateValue = { 'showWorkspace': payload.showWorkspace }
        // }
        // await categoriesService.patch(payload._id, {
        //     $set: updateValue
        // });
        // await dispatch.lifeCycle.getCategoryAsync({ "accountId": payload.accountId });
        // }
        // else if (payload.categoryType === 'category') {
        //     await categoriesService.patch(null,
        //         { "categories.$.name": payload.updatedName },
        //         {
        //             query: {
        //                 _id: payload.baseCategory,
        //                 "categories._id": payload._id
        //             }
        //         })
        //     await dispatch.account.setIsCategoryChange(true);
        // }
        // if (payload.image) {
        //     updateValue = { 'image': payload.image }
        // }
        // await categoriesService.patch(payload._id, {
        //     $set: updateValue
        // });
        // await dispatch.lifeCycle.getCategoryAsync({ "accountId": payload.accountId });
        // // }
        // // else if (payload.categoryType === 'category') {
        // //     await categoriesService.patch(null,
        // //         { "categories.$.name": payload.updatedName },
        // //         {
        // //             query: {
        // //                 _id: payload.baseCategory,
        // //                 "categories._id": payload._id
        // //             }
        // //         })
        // //     await dispatch.account.setIsCategoryChange(true);
        // // }
        // // else if (payload.categoryType === 'subCategory') {
        // //     payload.updateString = 'subCategoryUpdate'
        // //     await categoriesService.patch(payload.baseCategory, payload);
        // //     await dispatch.account.setIsCategoryChange(true);
        // // }
        // // await dispatch.lifeCycle.getCategoryTreeAsync({ "accountId": payload.accountId });
        // toastr.success('Message', 'Category Updated successfully')
      } catch (error) {
        throw error;
      }
    },
    async updateCategoryData(payload) {
      await categoriesService.patch(payload._id, payload);
      await dispatch.lifeCycle.getCategoryAsync({
        accountId: payload.accountId,
      });
    },
    async checkCategoryAsync(payload) {
      try {
        await checkCategoryService.find({ query: payload });
      } catch (e) {
        throw e;
      }
    },
    setDeleteCategoryModal(payload) {
      dispatch.account.setDeleteCategoryModalFlag(payload);
    },

    setSelectedCategoryAsync(payload) {
      dispatch.account.setSelectedCategory(payload);
    },
    setTreeIdFromParams(payload) {
      dispatch.account.paramsTreeId(payload);
    },

    async updateAccountDetails(payload) {
      try {
        await accountService.patch(payload.accountId, {
          $set: payload.data,
        });

        let accountDetails = await accountService.get(payload.accountId);
        await dispatch.app.setSelectedAccountData(accountDetails);
      } catch (err) {
        throw err;
      }
    },

    async getInviteByAccountIdAsync(payload) {
      try {
        const InviteData = await invitesService.find({
          query: {
            accountId: payload,
            isAccepted: false,
            isIndirect: false,
            $populate: [
              {
                path: "from",
                populate: "from",
                select: "_id firstName lastName",
              },
              {
                path: "referenceId",
                populate: "referenceId",
                select: "_id name",
              },
            ],
          },
          accountOnly: true,
        });
        // const declinedInvites = await declinedInvitesService.find({
        //   query: {
        //     accountId: payload,
        //     $populate: [
        //       {
        //         path: "from",
        //         populate: "from",
        //         select: "_id firstName lastName",
        //       },
        //       {
        //         path: "referenceId",
        //         populate: "referenceId",
        //         select: "_id name",
        //       },
        //     ],
        //   },
        // });
        // let allInvites = InviteData.data.concat(declinedInvites.data);
        dispatch.account.setAccountInvitedUserData(InviteData.data);
      } catch (err) {
        toastr.error("Message", "Failed to get the Invitaions.");
        throw err;
      }
    },

    async updateSelectedAccountState(payload, state) {
      if (
        state.app.selectedAccount &&
        state.app.selectedAccount._id.toString() === payload._id.toString()
      ) {
        const accountDetails = await accountService.get(payload._id, {
          query: {
            $populate: [
              {
                path: "users.id",
                select: "_id firstName lastName profilePic email",
              },
              {
                path: "integrations.id",
                select:
                  "_id id label image version description createdAt formBuilder",
              },
            ],
          },
        });
        await dispatch.app.setSelectedAccountData(accountDetails);
      }
    },

    async deactivateAccount(payload, state) {
      await deactivateAccountService.patch(payload.subscriptionId, payload);
      dispatch.platform.getAllAccountsWithOwnerDetails(
        state.platform.subscriptionListQuery
      );
    },

    async reactivateAccount(payload, state) {
      await activateAccountService.patch(payload.subscriptionId, payload);
      dispatch.platform.getAllAccountsWithOwnerDetails(
        state.platform.subscriptionListQuery
      );
    },

    async upgradeAccount(payload) {
      try {
        await accountUpgradeService.patch(payload.accountId, payload.data);

        // let accountDetails = await accountUpgradeService.get(payload.accountId);
        let accountDetails = await accountService.get(payload.accountId);
        await dispatch.app.setSelectedAccountData(accountDetails);
      } catch (err) {
        throw err;
      }
    },
    async createAccount(payload,state) {
      try {
        let accountDetails = await createSubscriptionService.create(payload);
        await dispatch.app.setSelectedAccountData(accountDetails);
        dispatch(push(`/createWorkspace/${accountDetails._id}`))
      } catch (err) {
        throw err;
      }
    },
    async reactivateAccountUsingStripe(payload,state){
      try {
        payload.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let accountDetails = await createSubscriptionService.create(payload);
        await dispatch.app.setSelectedAccountData(accountDetails);
      } catch (err) {
        throw err;
      }
    },
    async getAccountTagsTree(payload) {
      let tagsTree = await tagsTreeService.find();
      dispatch.account.setTagsTree(tagsTree);
    },
    async getAccountTags(payload) {
      let tags = await tagsService.find(payload);
      dispatch.account.setTags(tags.data);
    },
    async createTag(payload) {
      await tagsService.create(payload);
    },
    addNewTag(payload, state) {
      if (
        payload.accountId.toString() ===
        state.app.selectedAccount._id.toString()
      ) {
        if (state.community.mainAreaContext === "tags") {
          if (
            state.account.selectedTag._id &&
            payload.parent &&
            state.account.selectedTag._id.toString() ===
              payload.parent.toString()
          ) {
            state.account.tags.push(payload);
          } else if (!state.account.selectedTag._id && !payload.parent) {
            state.account.tags.push(payload);
          }
          dispatch.account.setTags(Object.assign([], state.account.tags));
          dispatch.account.getAccountTagsTree();
        }
      }
    },
    async removeTag(payload) {
      await tagsService.remove(payload);
    },
    removeTagFromList(payload, state) {
      const getTagIndex = (tags, id) => {
        for (let [index, tag] of tags.entries()) {
          if (tag._id.toString() === id.toString()) {
            return index;
          }
        }
        return -1;
      };
      if (
        payload.accountId.toString() ===
        state.app.selectedAccount._id.toString()
      ) {
        if (state.community.mainAreaContext === "tags") {
          let index = getTagIndex(state.account.tags, payload._id);
          dispatch.account.getAccountTagsTree();
          if (index !== -1) {
            let newTags = [
              ...state.account.tags.slice(0, index),
              ...state.account.tags.slice(index + 1),
            ];
            dispatch.account.setTags(Object.assign([], newTags));

            if (
              payload.parent &&
              payload.children &&
              payload.children.length > 0
            ) {
              return dispatch(
                push(
                  `/app/${payload.accountId}/settings/tags/${payload.parent}`
                )
              );
            } else if (!payload.parent) {
              return dispatch(push(`/app/${payload.accountId}/settings/tags`));
            }
          } else if (
            state.account.selectedTag &&
            state.account.selectedTag._id &&
            state.account.selectedTag._id.toString() === payload._id.toString()
          ) {
            if (payload.parent && state.account.selectedTag.tag) {
              return dispatch(
                push(
                  `/app/${payload.accountId}/settings/tags/${payload.parent}`
                )
              );
            } else if (!payload.parent) {
              return dispatch(push(`/app/${payload.accountId}/settings/tags`));
            }
          }
        }
      }
    },
    async setSelectedTagById(payload) {
      let tag = await tagsService.get(payload);
      dispatch.account.setSelectedTag(tag);
    },
    async updateTag(payload) {
      await tagsService.patch(payload._id, {
        $set: { name: payload.name, description: payload.description },
      });
    },
    updateTagInList(payload, state) {
      if (
        payload.accountId.toString() ===
        state.app.selectedAccount._id.toString()
      ) {
        if (state.community.mainAreaContext === "tags") {
          if (
            state.account.selectedTag._id &&
            payload.parent &&
            state.account.selectedTag._id.toString() ===
              payload.parent.toString()
          ) {
            for (let i = 0; i < state.account.tags.length; i++) {
              if (
                state.account.tags[i]._id.toString() === payload._id.toString()
              ) {
                state.account.tags[i] = Object.assign({}, payload);
              }
            }
          } else if (!state.account.selectedTag._id && !payload.parent) {
            for (let i = 0; i < state.account.tags.length; i++) {
              if (
                state.account.tags[i]._id.toString() === payload._id.toString()
              ) {
                state.account.tags[i] = Object.assign({}, payload);
              }
            }
          }
          dispatch.account.setTags(Object.assign([], state.account.tags));
          dispatch.account.getAccountTagsTree();
        }
      }
    },
    async checkTagUsage(payload) {
      await tagUsageService.get(payload);
    },
    async updatePublicAccess(payload) {
      await publicAccessService.patch(payload.accountId, {
        publicAccess: payload.publicAccess,
        reason: payload.reason,
      });
    },
    async topUpFreeCredits(payload, state) {
      const result = await topUpFreeCreditsService.patch(payload.accountId, {
        accountId: payload.accountId,
        amount: payload.amount,
      });

      if (state.app.selectedAccount) {
        dispatch.app.setAccountDetails({
          ...state.app.selectedAccount,
          freeCreditsRemaining: result.freeCreditsRemaining,
        });
      }

      if (state.app.accountSubscriptionDetail) {
        dispatch.app.accountSubDetails({
          ...state.app.accountSubscriptionDetail,
          usageMeter: {
            ...state.app.accountSubscriptionDetail.usageMeter,
            allowedLimit:
              (state.app.accountSubscriptionDetail.usageMeter.allowedLimit || 0) +
              result.toppedUpAmount,
          },
        });
      }

      return result;
    },
    updateOrganizationList(payload, state) {
      if (
        state.app.selectedAccount &&
        state.app.selectedAccount._id &&
        payload.accountId.toString() ===
          state.app.selectedAccount._id.toString()
      ) {
        if (
          state.account.organizationList &&
          state.account.organizationList.total > 0
        ) {
          for (let org of state.account.organizationList.data) {
            if (org._id.toString() === payload._id.toString()) {
              org.name = payload.name;
              org.fullControl = payload.fullControl;
              break;
            }
          }

          dispatch.account.setOrganizationList(
            Object.assign({}, state.account.organizationList)
          );
        }
        if (
          state.app.selectedOrganisation &&
          state.app.selectedOrganisation._id &&
          state.app.selectedOrganisation._id.toString() ===
            payload._id.toString()
        ) {
          if (!payload.id) {
            payload.id = payload._id;
          }
          // dispatch.app.setOrganisation(payload)
        }
      }
    },
    async getCategoriesToExport(payload, state) {
      try {
        let categoriesToExport = await categoriesExportService.get(payload);
        dispatch.account.setCategoriesToExport(categoriesToExport);
      } catch (err) {
        throw err;
      }
    },
    async importCategories(payload, state) {
      let importedCategories;
      if(payload.organisationId){
        importedCategories = await categoriesWorkspaceImportService.create({
          data: payload,
        });
      } else {
        importedCategories = await categoriesImportService.create({
          data: payload,
        });
      }
      if (!importedCategories || importedCategories.isFailed) {
        toastr.error("Message", "Error while importing the content.");
      } else if (importedCategories.failureCounter > 0) {
        toastr.warning(
          "Message",
          "Skipped " +
            importedCategories.failureCounter +
            " records with duplicate name"
        );
      } else {
        toastr.success(`Knowledge bank(s) imported successfully.`);
      }
    },
    async getAPIKeyDetails(payload, state) {
      let orgData = await organizationAPIKeyService.find();
      dispatch.account.setOrgsWithAPIKeys(orgData);
    },
    async createAPiKey(payload) {
      await apiKeyService.create(payload);
      dispatch.account.getAPIKeyDetails();
    },
    async updateClientAppUrlDomainData(payload, state) {
      await apiKeyService.patch(
        payload.apiKeyId,
        {
          clientAppUrl: payload.clientAppUrl,
          oauthDomain: payload.oauthDomain,
        },
        {
          query: {
            accountId: state.app.selectedAccount._id,
          },
        }
      );
      dispatch.account.getAPIKeyDetails();
    },
    async getConsumptionDetails(payload, state) {
      try{
      let consumptionDetails = await GetConsumptionDetailsService.find({"query": payload});
      const totalActivitiesGenerated = sumActivitiesGenerated(consumptionDetails);
      dispatch.account.setActivitiesGenerated(totalActivitiesGenerated);
      const totalLinksGenerated = sumLinksGenerated(consumptionDetails);
      dispatch.account.setLinksGenerated(totalLinksGenerated);
      const playbookCompleteCount = countPlaybookComplete(consumptionDetails);
      dispatch.account.setPlaybooksCreated(playbookCompleteCount);
      dispatch.account.setConsumptionDetails(consumptionDetails);
      } catch (error) {
        console.error("Error while fetching consumption details", error);
      }
    },
    async getBillingDefaulfs(payload = {}, state) {
      try{
        let billingDefaults = await ConsumptionBillingService.find({query: { type: 'default' } });
        dispatch.account.setBillingDefaults(billingDefaults && billingDefaults.data && billingDefaults.data.length > 0 && billingDefaults.data[0] || {});
      } catch (error) {
        console.error("Error while fetching billing defaults", error);
      }
    },
    async addOrUpdateBillingDefaults (payload, state) {
      try{
        let billingDefaultsRecord = await ConsumptionBillingService.find({ query: { type: 'default' } });
        let billingDefaults = billingDefaultsRecord && billingDefaultsRecord.data && billingDefaultsRecord.data.length > 0 && billingDefaultsRecord.data[0] || {};
        if(billingDefaults && billingDefaults._id){
          let updatedBillingDefaults = await ConsumptionBillingService.patch(billingDefaults._id, payload);
          await dispatch.account.setBillingDefaults(updatedBillingDefaults);
        } else {
          payload.type = 'default'
          let newBillingDefaults = await ConsumptionBillingService.create(payload);
          dispatch.account.setBillingDefaults(newBillingDefaults);
        }
      } catch (error) {
        console.error("Error while adding/updating billing defaults", error);
      }
    },
    async exportConsumptionDetails (payload, state) {
      const exportData = await ExportConsumptionDetailsExcelService.create(payload);
      function s2ab(s) {
          let buf = new ArrayBuffer(s.length);
          let view = new Uint8Array(buf);
          for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
          return buf;
        }
        let blob = new Blob([s2ab(atob(exportData))], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'Consumption Details.xlsx';
        link.click();
      return true;
    }
  },
};
function sumActivitiesGenerated(events) {
  if (!Array.isArray(events)) return 0;
  const targetEvents = ["PlaybookComplete", "StageActivitiesRegenerated"];
  return events.reduce((sum, event) => {
    if (targetEvents.includes(event.data.event)) {
      const activities = event.data && event.data.activitiesGenerated || 0;
      sum += activities;
    }
    return sum;
  }, 0);
}

function sumLinksGenerated(events) {
  if (!Array.isArray(events)) return 0;
  return events.reduce((sum, event) => {
    if (event.data.event === "ActivityDetailsGenerated") {
      const links = event.data && event.data.linksGenerated || 0;
      sum += links;
    }
    return sum;
  }, 0);
}

function countPlaybookComplete(events) {
  if (!Array.isArray(events)) return 0;
  return events.reduce((count, event) => {
    return event.data.event === "PlaybookComplete" ? count + 1 : count;
  }, 0);
}
